import React from 'react';
import OrderForm from 'pages/staples-bulk-orders/OrderForm';
import PdfViewer from 'pages/staples-bulk-orders/PdfViewer';
import { Wrapper } from 'styles/pages/staples-bulk-orders';

const Body = ({ state, setState }) => (
  <Wrapper>
    <OrderForm state={state} setState={setState} />
    <PdfViewer state={state} />
  </Wrapper>
);

export default Body;
